// src/constants/pickupTypes.ts
export const pickupTypes: Array<string> = ["passphrase", "license"];

export function getPickupTypeOptions() {
  return pickupTypes.map((value) => ({
    value,
    label: value === "passphrase" ? "Pickup by Passphrase" : "Pickup by License",
  }));
}
